module.exports = __webpack_public_path__ + "img/plus.b76a87dc.svg";